import {
  RadioButtonGroupMapping,
  RadioButtonType,
  RadioButtonsV2,
} from '@labrav/react-components'
import { Typography } from '@mui/material'
import { useStyles } from './RenewalSection.styles'
import { FormikProps } from 'formik'

export const renewalOptions: RadioButtonGroupMapping[] = [
  {
    key: 'Yes',
    label: 'Yes',
    type: RadioButtonType.STANDARD,
  },
  {
    key: 'No',
    label: 'No',
    type: RadioButtonType.STANDARD,
  },
]

export const RenewalSection = ({
  formik,
}: {
  formik: FormikProps<Record<string, unknown>>
}) => {
  const { values, setFieldValue, errors, touched, setFieldTouched } = formik
  const { classes } = useStyles()

  const handleRenewalChnage = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value
    await setFieldTouched('renewal', true)
    if (value === 'Yes') {
      await setFieldValue('renewal', true)
      await setFieldValue('renewalChannel', 'AWS_MARKETPLACE')
    } else if (value === 'No') {
      await setFieldValue('renewal', false)
      await setFieldValue('renewalChannel', null)
    } else {
      await setFieldValue('renewal', '')
      await setFieldValue('renewalChannel', null)
    }
  }
  const renewalValue = values.renewal
    ? 'Yes'
    : values.renewal === false
      ? 'No'
      : ''
  return (
    <div className={classes.sectionContainer} data-testid="renewal-section">
      <Typography className={classes.sectionHeading}>
        Is this offer intended to renew an existing paid contract with an
        existing customer for the same underlying product?
      </Typography>
      <div className={classes.radioButton}>
        <RadioButtonsV2
          name={'renewal'}
          checkedValue={{
            key: renewalValue as string,
            value: renewalValue as string,
          }}
          handleChange={handleRenewalChnage}
          radioButtonMappings={renewalOptions as RadioButtonGroupMapping[]}
          gapBetween={'16px'}
        />
        {!!touched?.renewal && errors?.renewal && (
          <div className={classes.errorMessage} data-testid={'renewal-error'}>
            {errors?.renewal}
          </div>
        )}
      </div>
    </div>
  )
}
